import './scss/index.scss';
import carousel from './js/carousel';


carousel();
